import { z } from 'zod';

/** Staff offline customer phone: 7–20 chars, digits and + - space (). */
export const offlinePhoneSchema = z
  .string()
  .trim()
  .min(7, 'customer.phone.tooShort')
  .max(20, 'customer.phone.tooLong')
  .regex(/^[0-9+\- ()]+$/, 'customer.phone.invalid');

export const identifyCustomerSchema = z.object({
  phoneNumber: offlinePhoneSchema,
});

export type IdentifyCustomerValues = z.infer<typeof identifyCustomerSchema>;

export const checkoutCustomerSchema = z.object({
  customerName: z.string().trim().max(120, 'checkout.nameTooLong'),
  phoneNumber: z
    .string()
    .trim()
    .refine((value) => value.length === 0 || offlinePhoneSchema.safeParse(value).success, {
      message: 'customer.phone.invalid',
    }),
});

export type CheckoutCustomerValues = z.infer<typeof checkoutCustomerSchema>;
